<button mat-stroked-button mat-dialog-close color="primary" class="me-1" >
        <mat-icon [class]="theme.myIconColor">close</mat-icon>  Cancel
</button>
    
